// @flow

import { toastr } from "react-redux-toastr";

import { makeApiCall } from "../../../../../services/apiService/apiService";

export const buSettingsActions = {
  GET_ALL_BU_TYPES: "GET_ALL_BU_TYPES",
  BU_SUBMIT: "BU_SUBMIT",
  GET_TICKETING_USERS: "GET_TICKETING_USERS"
};

export const getBuTypesAction = (obj: Object) => ({
  type: buSettingsActions.GET_ALL_BU_TYPES,
  payload: obj
});

export const buSettingsSubmitAction = (obj: Object) => ({
  type: buSettingsActions.BU_SUBMIT,
  payload: obj
});

export const getTicketingUsersAction = (obj: Object) => ({
  type: buSettingsActions.GET_TICKETING_USERS,
  payload: obj
});

export const getBuTypes = () => (dispatch: Function) => {
  dispatch(
    getBuTypesAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getBuTypes",
    successCb: res => {
      // eslint-disable-next-line
      console.log("Fetched all BU types ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getBuTypesAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getBuTypesAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in fetching BU types ", res);
      dispatch(
        getBuTypesAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in fetching BU types ", res);
      dispatch(
        getBuTypesAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const buSettingsSubmit = (formData: Object) => (dispatch: Function) => {
  dispatch(
    buSettingsSubmitAction({
      isLoading: true,
      isLoaded: false,
      data: null
    })
  );

  // eslint-disable-next-line
  console.log("BU Settings Data: ", formData);
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "ticketingBUSettings",
    method: "PUT",
    replaceParamsArr: [
      { key: "userEmailList", val: formData.userEmailList },
      { key: "groupCn", val: formData.permission }
    ],
    successCb: res => {
      //  eslint-disable-next-line
      console.log("Fetched BU Submit data ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          buSettingsSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        dispatch(
          buSettingsSubmitAction({
            isLoading: false,
            isLoaded: true,
            data: null
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in BU settings submit, res = ", res);
      dispatch(
        buSettingsSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in BU settings submit, res = ", res);
      dispatch(
        buSettingsSubmitAction({
          isLoading: false,
          isLoaded: true,
          data: null
        })
      );
    }
  };
  makeApiCall(requestObj);
};

export const getTicketingUsers = searchText => (dispatch: Function) => {
  dispatch(
    getTicketingUsersAction({
      isLoading: true,
      isLoaded: false,
      data: []
    })
  );
  const requestObj = {
    baseUrl: "ticketingApiUrl",
    apiEndPoint: "getTicketingUsers",
    replaceParamsArr: [{ key: "searchText", val: searchText }],
    successCb: res => {
      // eslint-disable-next-line
      console.log("Fetched ticketing users ", res);
      if (res.status === "SUCCESS") {
        dispatch(
          getTicketingUsersAction({
            isLoading: false,
            isLoaded: true,
            data: res.response
          })
        );
      } else if (res.status === "FAILURE") {
        toastr.error("Error", res.errorMessage);
        dispatch(
          getTicketingUsersAction({
            isLoading: false,
            isLoaded: true,
            data: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log("Failure in fetching ticketing users ", res);
      dispatch(
        getTicketingUsersAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log("Exception in fetching ticketing users ", res);
      dispatch(
        getTicketingUsersAction({
          isLoading: false,
          isLoaded: true,
          data: []
        })
      );
    }
  };
  makeApiCall(requestObj);
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/buSettings/buSettingsRedux/buSettingsActionCreator.js